import request from '@/utils/request';

/**
 * 获取分页配送模板
 * @param params
 */
export function getDeliveryTemplateList(params) {
  return request({
    url: '/admin/merchant/shipping/template/list',
    method: 'get',
    params: params
  });
}

/**
 * 获取配送模板详情
 * @param id
 */
export function getDeliveryTemplateInfo(id) {
  return request({
    url: "/admin/merchant/shipping/template/info/".concat(id),
    method: 'get'
  });
}

/**
 * 新增运费模板
 * @param data
 */
export function createDeliveryTemplate(data) {
  return request({
    url: '/admin/merchant/shipping/template/save',
    method: 'post',
    data: data
  });
}

/**
 * 编辑运费模板
 * @param data
 */
export function updateDeliveryTemplate(data) {
  return request({
    url: '/admin/merchant/shipping/template/update',
    method: 'post',
    data: data
  });
}

/**
 * 删除运费模板
 * @param id
 */
export function deleteDeliveryTemplate(id) {
  return request({
    url: "/admin/merchant/shipping/template/delete/".concat(id),
    method: 'get'
  });
}